<template>
	<UiDialog
		ref="uiFilterListMobileModal"
		width="500px"
		title="Фильтр"
		without-footer
		without-scroll
	>
		<UiFilterList
			:filters="filters"
			:initialFilters="initialFilters"
			mobile
			@changeMobile="e => changeMobile(e)"
		/>
	</UiDialog>
</template>

<script>

export default {
	name: 'UiFilterListMobileModal',
	props: {
		filters: {
			type: Array,
			default: () => [],
		},
		initialFilters: {
			type: Object,
			default: () => ({}),
		},
	},
	methods: {
		show() {
			this.$refs.uiFilterListMobileModal.show();
		},
		changeMobile(e) {
			this.$emit('change', e);
			this.$refs.uiFilterListMobileModal.closeModal();
		},
	}
}  
</script>
